import {
  FRIDGE_FULFILLMENT_COLLECT,
  FRIDGE_FULFILLMENT_DELIVERY,
  FRIDGE_FULFILLMENT_ROYALMAIL,
  CONTROLLED_DRUG_COLLECT,
  CONTROLLED_DRUG_DELIVERY,
  CONTROLLED_DRUG_ROYALMAIL,
  GA_EVENTS,
} from 'helpers/monitoringEvents';

const getDeliveryOptions = (selectedPharmacyUser, pharmaciesInRange) => {
  return {
    homeDelivery: {
      payload: 'homeDelivery',
      location: '/pharmacy/dashboard/delivery-details',
      event: {
        fridgeline: {
          logEvent: FRIDGE_FULFILLMENT_ROYALMAIL,
          ga: GA_EVENTS.FRIDGE_LINE.FRIDGE_FULFILLMENT_ROYALMAIL,
        },
        controlled: {
          logEvent: CONTROLLED_DRUG_ROYALMAIL,
          ga: GA_EVENTS.CONTROLLED_DRUG.CONTROLLED_DRUG_ROYALMAIL,
        },
      },
    },
    collectFromPharmacy: {
      payload: 'collectFromPharmacy',
      location: selectedPharmacyUser ? '/pharmacy/dashboard/basket' : '/pharmacy/dashboard/find-pharmacy',
      event: {
        fridgeline: {
          logEvent: FRIDGE_FULFILLMENT_COLLECT,
          ga: GA_EVENTS.FRIDGE_LINE.FRIDGE_FULFILLMENT_COLLECT,
        },
        controlled: {
          logEvent: CONTROLLED_DRUG_COLLECT,
          ga: GA_EVENTS.CONTROLLED_DRUG.CONTROLLED_DRUG_COLLECT,
        },
      },
    },
    pharmacyDelivery: {
      payload: 'pharmacyDelivery',
      location:
        selectedPharmacyUser || pharmaciesInRange?.length === 1
          ? '/pharmacy/dashboard/basket'
          : '/pharmacy/dashboard/pharmacy-delivery',
      event: {
        fridgeline: {
          logEvent: FRIDGE_FULFILLMENT_DELIVERY,
          ga: GA_EVENTS.FRIDGE_LINE.FRIDGE_FULFILLMENT_DELIVERY,
        },
        controlled: {
          logEvent: CONTROLLED_DRUG_DELIVERY,
          ga: GA_EVENTS.CONTROLLED_DRUG.CONTROLLED_DRUG_DELIVERY,
        },
      },
    },
  };
};

export default getDeliveryOptions